import React, { useState, useEffect } from "react"

import ReactPlayer from "react-player"
import { Link } from "gatsby"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
// import ConditionalWrapper from "../../ConditionalWrapper/ConditionalWrapper"

import "./carouselItem.scss"
const CarouselItem = (props) => {
  const [open, setOpen] = useState(false)
  const [currentTime, setCurrentTime] = useState("")
  const [isPlaying, setIsPlaying] = useState(false)

  const handleClickOpen = (e) => {
    setOpen(true)
    setIsPlaying(false)
  }

  const handleClose = (e) => {
    setOpen(false)
  }

  const getWindowDimensions = () => {
    if (typeof window !== "undefined") {
      const { innerWidth: width, innerHeight: height } = window
      return {
        width,
        height,
      }
    } else {
      return {
        width: 0,
        height: 0,
      }
    }
  }

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    )

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions())
      }

      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [])

    return windowDimensions
  }

  const { image, video, video_iframe, url } = props
  const { height, width } = useWindowDimensions()

  return (
    <div className="carousel_content">
      <div
        className="pic"
        role="presentation"
        onMouseEnter={(e) => {
          setIsPlaying(true)
        }}
        onMouseLeave={(e) => {
          setIsPlaying(false)
        }}
        onMouseOut={(e) => {
          if (isPlaying === false) {
            setIsPlaying(false)
          }
        }}
      >
        <div
          className="image-wrapper"
          onClick={() => (width < 1024 ? setIsPlaying(true) : null)}
        >
          {width < 1024 ? (
            <img
              src={image}
              alt="footer-carousel-image"
              onClick={() => {
                handleClickOpen()
              }}
            />
          ) : (
            <img src={image} alt="footer-carousel-image" />
          )}
        </div>
        {width > 1024 ? (
          isPlaying ? (
            <ReactPlayer
              url={
                video ||
                "https://cdn.api.video/vod/vi4DvTaA9NBOqrN0hagRcuH9/hls/manifest.m3u8"
              }
              className={"industries-item-video"}
              width={"100%"}
              height={"auto"}
              playing={isPlaying}
              onClick={() => {
                handleClickOpen()
              }}
            />
          ) : null
        ) : null}

        <Dialog
          className={`device-dialog dialogWrapper`}
          // fullScreen={this.state.fullScreen}
          open={open}
          onClose={() => handleClose()}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent className="dialog">
            <div
              className="video_iframe"
              dangerouslySetInnerHTML={{ __html: video_iframe }}
            ></div>
            {url ? (
              <Link to={url}>
                <div className="dialog_route_subpage">tovább az aloldalra</div>
              </Link>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  )
}

export default CarouselItem
